import { useEffect, useState } from 'react'
import { Brand } from '../components/common/Brand'
import { isSupabaseConfigured, supabase } from '../lib/supabase'

type ServiceStatus = 'operational' | 'checking' | 'outage'

export function StatusPage() {
  const [services, setServices] = useState<
    Record<'site' | 'api' | 'database', ServiceStatus>
  >({
    site: 'operational',
    api: isSupabaseConfigured ? 'checking' : 'outage',
    database: isSupabaseConfigured ? 'checking' : 'outage'
  })
  const [checkedAt, setCheckedAt] = useState<string | null>(null)

  useEffect(() => {
    if (!supabase) return
    async function checkServices() {
      const { error: apiError } = await supabase!.functions.invoke('waitlist', {
        body: { action: 'ping' }
      })
      const { error: databaseError } = apiError
        ? { error: true }
        : await supabase!.functions.invoke('waitlist', {
            body: { action: 'health' }
          })
      setServices({
        site: 'operational',
        api: apiError ? 'outage' : 'operational',
        database: databaseError ? 'outage' : 'operational'
      })
      setCheckedAt(
        new Date().toLocaleTimeString('en-IN', {
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          timeZone: 'Asia/Kolkata'
        })
      )
    }
    checkServices()
  }, [])

  const serviceList: [string, string, ServiceStatus][] = [
    ['Website', 'The ihatecp landing page', services.site],
    ['Waitlist API', 'Signup and preferences endpoint', services.api],
    ['Database', 'Waitlist data storage', services.database]
  ]

  return (
    <main className="status-page">
      <nav className="nav">
        <Brand />
      </nav>
      <section className="status-content">
        <p className="tag">
          <span className="spark">✦</span> System status
        </p>
        <h1>
          Everything is
          <br />
          <em>looking good.</em>
        </h1>
        <p className="status-intro">
          Live availability for the ihatecp experience.
        </p>
        <div className="status-list">
          {serviceList.map(([name, detail, status]) => (
            <div className="status-item" key={name}>
              <div>
                <h2>{name}</h2>
                <p>{detail}</p>
              </div>
              <span className={`service-status ${status}`}>
                <i />
                {status === 'checking'
                  ? 'Checking'
                  : status === 'outage'
                    ? 'Issue detected'
                    : 'Operational'}
              </span>
            </div>
          ))}
        </div>
        <p className="status-checked">
          {checkedAt
            ? `Last checked ${checkedAt} IST`
            : isSupabaseConfigured
              ? 'Checking services…'
              : 'Supabase configuration is unavailable.'}
        </p>
        <a className="status-home" href="/">
          ← Back to ihatecp
        </a>
      </section>
    </main>
  )
}
